@if (accessibilityPath && accessibilityFile && accessibilityRouterPath) {
  <div>
    <ch-manual
      [assetsPath]="accessibilityPath"
      [page]="accessibilityFile"
      [showControls]="false"
      [addContainer]="true"
      [routerPath]="accessibilityRouterPath"
      [manualStyles]="false"></ch-manual>
  </div>
}
